module.exports = __webpack_public_path__ + "img/expense-dashboard-icon.d9804e1.png";